export const API_ROUTES = {
  GET_ENVELOPE_OR_CREATE: 'envelope/find-or-create',
  RESOLVE_ENVELOPE: 'envelope/resolve',
  LINK_ENVELOPE_TO_INSTANCE: 'envelope/:envelopeId/link-instance',
  UPDATE_ENVELOPE_CONFIG: 'envelope/update-envelope-config/:envelopeId',
  UPDATE_USE_FILE_COLUMN:
    'envelope/update-envelope-config/:envelopeId/use-file-column',
  UPDATE_PRESIGNED_FILE_COLUMN:
    'envelope/update-envelope-config/:envelopeId/presigned-file-column',
  SEND_VERIFICATION_EMAIL: 'envelope/send-verification-email/:envelopeId',
  GET_FILES_ITEM: 'files',
  UPDATE_DOCUMENT: 'files/:fileId',
  DELETE_DOCUMENT: 'files/:fileId',
  DELETE_DOCUMENT_BY_ASSET_ID: 'files/by-asset-id/:assetId',
  UPLOAD_DOCUMENT: 'files/:envelopeId/:itemId',
  CREATE_FROM_ASSET_ID: 'files/from-asset-id/:assetId',

  TRIGGER_DOCUMENT_GENERATION: 'generate-flow/generate-documents',

  REQUEST_SIGNATURE: 'signing-flow/request-signature',

  GET_SIGNER_DATA: 'signing-flow/signer-data',
  GET_DOCUMENT_HISTORY: 'signing-flow/history',
  DOWNLOAD_SIGNED_DOCUMENTS: 'signing-flow/download-signed-documents',
  CANCEL_SEND_REQUEST: 'signing-flow/cancel-sign-request',
  RESET_SIGNING_PROCESS: 'signing-flow/reset-process',
  REQUEST_SIGN_BY_ME: 'signing-flow/sign-by-me',

  DOWNLOAD_GENERATED_DOCUMENT: 'generate-flow/download-generated-documents',
  GET_PENDING_APPROVALS: 'approval-requests/pending',
  RESOLVE_APPROVAL_REQUEST: 'approval-requests/:id/resolve',

  GENERATE_SIGNING_LINK: 'signing-flow/generate-signing-link',
  COPY_SIGNING_LINK: 'signing-flow/copy-signing-link/:envelopeId/:itemId',
  COPY_INDIVIDUAL_SIGNING_LINK: 'signing-flow/get-individual-signing-link',

  GET_PROGRESS_STATUS:
    'envelope/get-progress-status?instanceId=:instanceId&boardId=:boardId',
  UPDATE_PROGRESS_STATUS: 'application/update-progress-status',

  GET_USAGE_STATS: 'billing/usage-stats/:accountId',

  GET_LOGO_PRESIGNED_URL: 'file-storage/logo/presigned-url',
  DELETE_LOGO: 'file-storage/logo',
  GET_LOGO: 'file-storage/logo',

  GET_DOCUMENT_GENERATION_PROGRESS:
    'generate-flow/generate-documents-progress/:jobId',
  CHECK_GENERATION_STATUS:
    'generate-flow/check-generation-in-progress?envelopeId=:envelopeId&itemId=:itemId',

  GET_USER_TEMPLATES: 'template-gallery/user-templates',
  SELECT_TEMPLATE_GALLERY_TEMPLATE:
    'template-gallery/select-template/:templateId',
  RENAME_TEMPLATE: 'template-gallery/rename-template/:templateId',
  VALIDATE_DELETE_TEMPLATE:
    'template-gallery/validate-delete-template/:templateId',
  DELETE_TEMPLATE: 'template-gallery/delete-template/:templateId',
  DUPLICATE_TEMPLATE: 'template-gallery/duplicate-template/:templateId',
  UPLOAD_TEMPLATE_TO_GALLERY: 'template-gallery/create-template',
  CONFIGURE_DOMAIN: 'domain/:envelopeId/configure',
  GET_DOMAIN: 'domain/:envelopeId',
  MARK_DNS_ADDED: 'domain/:domainId/mark-dns-added',
  VALIDATE_DNS: 'domain/:domainId/validate-dns',
  DELETE_DOMAIN: 'domain/:domainId',
  GET_MANUAL_RECIPIENTS: 'manual-recipients',
} as const;
